import { createAsyncThunk } from "@reduxjs/toolkit";

import { getClientStats as getClientStatsApi } from "../../helpers/fakebackend_helper";

// Unlike contractStats, ClientViewSet.stats returns the plain object
// directly (no {"data": ...} envelope) — see clients/views/client.py.
export const getClientStats = createAsyncThunk(
  "clientStats/getClientStats",
  async (queryParams) => {
    const response = await getClientStatsApi(queryParams);
    return response;
  }
);
